export const REDIRECT_URLS = {
  US: {
    REACT_APP_DEV_REDIRECT_URL: "https://dev.hillsretailorder.com/",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.com/",
    REACT_APP_PRD_REDIRECT_URL: "https://www.hillsvet.com/",
  },
  TW: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.tw/",
    REACT_APP_PRD_REDIRECT_URL: "https://hillsvet.tw/",
  },
  KR: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.hillsvet.co.kr/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.co.kr/",
  },
  JP: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.vet.hills.co.jp/",
    REACT_APP_PRD_REDIRECT_URL: "http://vet.hills.co.jp/",
  },
  DE: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.hillsvet.de/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.de/",
  },
  DE_CH: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.hillsvet.ch/de-ch/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.ch/de-ch/",
  },
  FR_CH: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.hillsvet.ch/fr-ch/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.ch/fr-ch/",
  },
  AT: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "http://stageaem-cloud.hillsvet.at/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.at/",
  },
  IT: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.it/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.it/",
  },
  NL: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.nl/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.nl/",
  },
  DK: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.dk/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.dk/",
  },
  NO: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.no/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.no/",
  },
  SE: {
    REACT_APP_DEV_REDIRECT_URL: "",
    REACT_APP_TST_REDIRECT_URL: "https://stageaem-cloud.hillsvet.se/",
    REACT_APP_PRD_REDIRECT_URL: "http://hillsvet.se/",
  },
};
